<template>
    <div class="md_login-panel">
        <div class="wrap">

            <!-- Input -->
            <form class="input-wrap" v-on:submit.prevent="submit">
                <div class="inner">

                    <div class="group _start">

                        <h2><span>Password Reset</span></h2>

                        <!-- Email -->
                        <div class="item form_text">
                            <input id="email" type="email" v-model="form.email" required autofocus readonly style="border:none"/>
                            <label for="email" class="m-label"><span>メールアドレス</span></label>
                        </div>

                        <!-- Password -->
                        <div class="item form_text">
                            <input type="password" id="password" placeholder=" " v-model="form.password" required autocomplete="new-password">
                            <label for="password" class="m-label"><span>新しいパスワードをご入力ください</span></label>
                        </div>

                        <div class="item form_text">
                            <input type="password" id="password_confirmatio" placeholder=" " v-model="form.password_confirmation" required autocomplete="new-password">
                            <label for="password_confirmation" class="m-label"><span>新しいパスワードを再入力（確認）</span></label>
                        </div>

                    </div>

                    <div class="group _end">

                        <div class="btn_link-wrap _w100">
                            <button type="submit" class="btn_link"  :class="{ 'opacity-25': form.processing }" v-bind:disabled="form.processing"><span>パスワードをリセットする</span></button>
                            <div class="bg-element"></div>
                        </div>
                    </div>

                </div>
            </form>

            <!-- Img -->
            <div class="img-wrap">
                <img src="/img/login-panel.jpg" alt="">
            </div>

        </div>
        <!-- BgText -->
        <div class="bg-text"><span>Password Reset</span></div>

    </div>
    <AlertModal 
        v-if="showAlertModal" 
        @close="closeAlertModal" 
        :title="alert_modal_title" 
        :message="alert_modal_message"
        :mode="alert_modal_mode" 
    />
</template>

<script>
    import { defineComponent } from 'vue';
    import { Head } from '@inertiajs/inertia-vue3';
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
    import EndUserLayout from '@/Layouts/EndUserLayout'
    import likeMixins from '@/common/like.js'
    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'

    export default defineComponent({
        mixins: [likeMixins],
        layout: EndUserLayout,
        components: {
            Head,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
            JetInput,
            JetLabel,
            JetValidationErrors,
            "AlertModal": AlertModal,
        },

        props: {
            email: String,
            token: String,
        },

        data() {
            return {
                form: this.$inertia.form({
                    token: this.token,
                    email: this.email,
                    password: '',
                    password_confirmation: '',
                    showAlertModal: false,
                    alert_modal_title: "",
                    alert_modal_message: "",
                    alert_modal_mode: ""
                }),
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.update'), {
                    onError: (errors) => {
                        console.log(errors);
                        if (errors.email) {
                            this.openAlertModal('error', 'エラー', errors.email); // 確認済み
                        }
                        if (errors.password) {
                            console.log(errors.password);
                            this.openAlertModal('error', 'エラー', errors.password); // 確認済み
                        }
                    },
                    onSuccess: () => {
                        // src/config/fortify.php Home Pathでflash message渡せさなさそうためalertのまま
                        alert('パスワードをリセットしました。新しいパスワードでログインしてください。'); 
                    },
                    onFinish: () => {
                        this.form.reset('password', 'password_confirmation');
                    },
                })
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = "";
                this.alert_modal_title = "";
                this.alert_modal_message = "";
            }
        }
    })
</script>
